import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={14} height={13} fill="none" xmlns="http://www.w3.org/2000/svg"><path clipRule="evenodd" d="M0 4h14v9H0V4zm1-2h12v1H1V2zm1-2h10v1H2V0z" /></svg>;
}
export default SvgComponent;